// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"26de99d1","513":"effe4f7e","703":"d61f4bb4","787":"cda612ba"}[chunkId] + ".chunk.js";
};